import { Stack, Title, Text, Paper, Container } from '@mantine/core'
import { FiltersAndSegmentsTable } from './table/FiltersAndSegmentsTable'
import './filters-and-segments.css'

const FiltersAndSegmentes = () => {
  return (
    <div className="filters-segments-container">
      <Container size="xl" py={40} px={60} /* h="calc(100vh - 210px)" */ h='100%'>
        <Stack spacing="xl">
          {/* Header Section */}
          <Paper p="xl" radius="md" withBorder className="filters-segments-header">
            <Stack spacing="xs">
              <Title order={2} size="h3" weight={600}>
                Filters & Segments
              </Title>
              <Text color="dimmed" size="sm" className="filter-description">
                Configure which filters are available across different pages in your application. 
                Expand each filter type to see and manage individual filter options.
              </Text>
            </Stack>
          </Paper>

          {/* Table Section */}
          <Paper radius="md" withBorder className="filters-segments-table">
            <FiltersAndSegmentsTable />
          </Paper>
        </Stack>
      </Container>
    </div>
  )
}

export default FiltersAndSegmentes